module.exports = __webpack_public_path__ + "img/fb5f109c566e62f644ca499c3fc1e9bd.png";